export const KeyNames = {
  TAB: 'Tab',
  ENTER: 'Enter',
}
